<template>
  <div class="d-md-none w-100 my-2 btn-group ec-ds-scope-dropdown ds-input" role="group">
    <button class="value-display list-group-item col w-100 d-flex flex-row justify-content-between p-0 align-items-center ec-ds-scope-dropdown-inlay"
            data-toggle="collapse" :data-target="toggleElementId" data-cy="btn-filter-toggle"
            @click="filterCollapsed = !filterCollapsed" id="btnGroupDrop3" type="button" aria-expanded="false">
      <div class="pl-2 h-100 mt-2 d-flex align-items-center font-weight-bold ec-ds-scope-text">
        {{ $t("message.datasetFacets.title") }}
      </div>
      <div class="ecl-select__icon ec-ds-scope-select">
        <svg class="ecl-icon ecl-icon--s ecl-icon--rotate-180 ecl-select__icon-shape ec-ds-scope-arrow" focusable="false" aria-hidden="true">
          <use xlink:href="@/assets/img/ecl/icons.svg#corner-arrow"></use>
        </svg>
      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "DatasetsMobileDropdown",
  props: {
    toggleElementId: String
  },
  data() {
    return {
      filterCollapsed: true
    }
  }
}
</script>

<style lang="scss" scoped>

.ec-ds-scope-dropdown {
  border-radius: 4px !important;
}

</style>

